import React, {PropsWithChildren} from 'react';
import './auth-layout.scss';

export interface AuthLayoutProps {

}

const AuthLayout = (props: PropsWithChildren<AuthLayoutProps>) => {

    return (
        <div className={'auth-main-content-wrapper'}>
            {props.children}
        </div>
    )
};

export default AuthLayout;
